/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'identity.account-menu.account-details.manage-profile-link': 'Configuración de la cuenta',
  'identity.account-menu.account-details.view-profile-tooltip': 'Perfil',
  'identity.account-menu.account-menu-content.log-out-button': 'Cerrar sesión',
  'identity.account-menu.account-menu-content.switch-account-button': 'Cambiar de cuenta',
  'identity.account-menu.account-menu-details.managed-account': '<b>{managedBy}</b> gestiona esta cuenta',
  'identity.account-menu.account-menu-logged-out-state.log-in': 'Iniciar sesión',
  'identity.account-menu.account-menu-popup.skeleton.tooltip': 'Cuenta',
  'identity.account-menu.theme-switcher.dark.option': 'Oscuro',
  'identity.account-menu.theme-switcher.light.option': 'Claro',
  'identity.account-menu.theme-switcher.match-browser.option': 'Igual que el navegador',
  'identity.account-menu.theme-switcher.theme-button': 'Tema',
};
